window.$ = window.jQuery = require('jquery');



require("jquery-mousewheel");
require('malihu-custom-scrollbar-plugin');


self.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
}

window.formatField = function (value) {
    return "<a href='/admin/dentists/" + value + "' class='tr-link'></a>" + value;
}

function DentistTable(el) {
    this.el = el;
    this.documentsData = '';
    this.dentistTable = this.el.find('.custom-order-table');
    this.dataType = this.el.attr('data-type');
    this.divToPrint = $('#divIdToPrint');
    this.el.find('.dropdown-menu').prepend('<span class="show-cols">Columns to be shown</span>');

//    this.el.find(".scroll-holder").mCustomScrollbar({
//        advanced: {autoExpandHorizontalScroll: false, updateOnContentResize: true},
//    });


    setTimeout(() => {
        this.customTable(this);
        this.bindEvents();
        this.customSearch();
    }, 0);
}

DentistTable.prototype = {
    customSearch: function () {
        var $search = $('.fixed-table-toolbar .search input');
        $search.attr('placeholder', 'Søk i ordre');
    },
    reBuildTable: function () {
        var obj = this;
//        var actions = function () {
//            return obj.el.find("tbody").mCustomScrollbar('destroy');
//        };
        var tbUpdate = debounce(obj.customTable, 1);
//        $.when(actions()).done(function () {
            tbUpdate(obj);
//        });
    },
    customTable: function (obj) {

        var tableWidth = $(obj.dentistTable).innerWidth(),
            thead = $(obj.dentistTable).find('thead'),
            tableHeadTH = $(obj.dentistTable).find('thead').find('th'),
            tableBodyTD = $(obj.dentistTable).find('tbody').find('tr:first-child td'),
            array = [],
            setTbodyHeight = (obj.el.closest('.full-width').height() - obj.el.siblings('.table-toolbar').outerHeight() - obj.el.find('.fixed-table-container').height()),
            action = function () {
                return  tableHeadTH.each(function (index, el) {
                    array.push(el.clientWidth);
                });
            };

        //obj.el.find('.order-table-wrapper').find('tbody').css({'max-height': setTbodyHeight});

        // promise function
        /*$.when(action()).done(function () {
            obj.el.find("tbody").mCustomScrollbar({
                snapAmount: 50,
                advanced: {autoExpandHorizontalScroll: false, updateOnContentResize: true},
                axis: "y",
                keyboard: {
                    enable: false,
                },
            });
            obj.el.find(".dropdown-menu").mCustomScrollbar();
            // tableBodyTD.each(function(index, el) {
            // 	$(el).css('width', array[index]);		
            // });
            // tableHeadTH.each(function(index, el) {
            // 	$(el).css('width', array[index]);		
            // });
        });*/


    },
    bindEvents: function () {
        var obj = this;
        var activeRow = '';
        var checkedRows = [];

        function selectRow(e) {
            e.stopPropagation();
            selectRowDebFn(e);
        }

        var selectRowDebFn = debounce(function (e) {

            if (e.which != 38 && e.which != 40) {
                return
            }
            if ((!obj.el.closest('.tab-pane').hasClass('show') && obj.previewBox.length)) {
                return;
            }

            switch (e.which) {
                case 38:

                    activeRow = obj.dentistTable.find('tr.active');
                    if (activeRow.prev().length) {
                        activeRow.removeClass('active');
                        setTimeout(function () {
                            activeRow.prev().addClass('active');
                        }, 0);
                    }

                    break;
                case 40: // down

                    activeRow = obj.dentistTable.find('tr.active');
                    if (activeRow.next().length) {
                        activeRow.removeClass('active');
                        setTimeout(function () {
                            activeRow.next().addClass('active');
                        }, 0);
                    }

                    break;
            }

//            setTimeout(function () {
//                obj.dentistTable.find("tbody").mCustomScrollbar("scrollTo", obj.dentistTable.find('tbody').find('tr.active'));
//
//            }, 0);
        }, 250);


        $(window).keydown(selectRow);

        $('.sync-ofc-btn').on('click', function(e) {
            $('#ajax-loader').show();
        });

        obj.dentistTable.on('click-row.bs.table', function (row, $element, field) {
            obj.dentistTable.find('tbody').find('tr').removeClass('active');
            field.addClass('active');
            window.location = field.find('.tr-link').attr('href');
            
        });

        obj.dentistTable.on('pre-body.bs.table', function () {

            obj.reBuildTable();
        });


        obj.dentistTable.on('check.bs.table', function (e, row) {
            checkedRows.push({id: Number(row.id), name: row.name, forks: row.forks});
            if ($(this).find('tr').hasClass('selected')) {
                $(this).find('tr').addClass('vis-checkbox');
                obj.el.siblings(".table-toolbar").find('.btns-box').addClass('vis-box');
            }
        });

        obj.dentistTable.on('uncheck.bs.table', function (e, row) {
            $.each(checkedRows, function (index, value) {
                if (!value) {
                    return;
                }
                if (value.id === row.id) {
                    checkedRows.splice(index, 1);
                }
            });
            if (!$(this).find('tr').hasClass('selected')) {
                $(this).find('tr').removeClass('vis-checkbox');
                obj.el.siblings(".table-toolbar").find('.btns-box').removeClass('vis-box');
            }
        });

        var deleteRequest = function (val) {
            return confirm('This will delete ' + val + ' rows. Do you want to continue?');
        }

        obj.el.siblings(".table-toolbar").find('.btn-delete-row').on('click', (event) => {
            if (!deleteRequest(checkedRows.length)) {
                return
            }
            $.each(checkedRows, function (index, value) {
                obj.dentistTable.bootstrapTable('removeByUniqueId', value.id);
            });
            event.preventDefault();
        });

        obj.el.siblings(".table-toolbar").find('.upload-zooze-btn').on('click', (event) => {
            event.preventDefault();
            checkedRows.forEach((value, index) => {
                $('.row-' + Number(value.id)).find('.buttons-wrap').toggleClass('visible-snooze');
            });

        });

        // print-documents
        obj.el.siblings(".table-toolbar").find('.print-documents-btn').on('click', (event) => {
            preloader.open('Loading documents', 'Please wait while we are preparing the documents ...');
            event.preventDefault();
        });

        obj.dentistTable.on('check-all.bs.table', function () {  // if have some troubles, we have to use this event: 'all.bs.table'
            $(this).find('tr').addClass('vis-checkbox');
            $('.btns-box').addClass('vis-box');
        });

        obj.dentistTable.on('uncheck-all.bs.table', function () {  // if have some troubles, we have to use this event: 'all.bs.table'
            $(this).find('tr').removeClass('vis-checkbox');
            $('.btns-box').removeClass('vis-box');
            obj.divToPrint.html('');
        });

        obj.el.find('.expand-btn').on('click', function (event) {
            obj.el.addClass('collapse-preview-box');
            obj.el.find('.hide-collapse').fadeOut(250, function () {
                obj.el.find('.expand-preview').fadeIn();
            });
            clearTimeout(collapse);
            var collapse = setTimeout(collapsing, 1310);

            function collapsing() {
                // $('#table').bootstrapTable('refresh');

                // obj.reBuildTable();
                // $("th[data-field='dentist'] .sortable").click();
                // $('.search').find('input[type="text"]').val('').trigger('keyup');
            }
            obj.el.find('.expand-preview').on('click', function (event) {
                obj.el.removeClass('collapse-preview-box');
                $(this).fadeOut(100);
                obj.el.find('.hide-collapse').fadeIn(250);
                clearTimeout(collapse);
                var collapse = setTimeout(collapsing, 1310);
                function collapsing() {
                    obj.reBuildTable();
                    // obj.el.find("th[data-field='dentist'] .sortable").click();
                }
            });
        });

        $('a[href="#' + obj.el.closest('.tab-pane').attr('id') + '"]').on('shown.bs.tab', function (e) {
            obj.reBuildTable();
        });

        obj.el.find('.snooze').on('click', function () {
            $(this).closest('.chats').toggleClass('visible-snooze');
        });

    }
}
export default DentistTable;